export default "__VITE_ASSET__3ab86ca2__"